import { PublicQuestion } from "@/queries/types";
import styled from "@emotion/styled";
import { DSTextAnswer } from "@hundred5/design-system";
import { useLingui } from "@lingui/react/macro";
import { Dispatch, useState } from "react";
import { useMedia } from "react-use";
import * as amplitude from "../../../../amplitude";
import { CodeEditor } from "../../../code-editor";
import { Action, State } from "../../reducer";
import DebouncedAnswer from "./debounced-answer";

interface Props {
  question: PublicQuestion;
  dispatch: Dispatch<Action>;
  state: State;
}

export function CodeAnswer({ question, dispatch, state }: Props) {
  const { t } = useLingui();
  const desktop = useMedia("(min-width: 768px)");
  const answer = state.answers[question.test_question_id];

  const [editorTimedOut, setEditorTimedOut] = useState(false);

  return (
    <DebouncedAnswer
      answer={answer?.freeTextAnswer || ""}
      onChange={(content) => {
        dispatch({
          type: "enter_text_answer",
          payload: {
            questionId: question.test_question_id.toString(),
            freeTextAnswer: content,
          },
        });

        amplitude.trackQuestionAnswer(
          state.jobOpeningSlug,
          state.activeQuestionIndex,
        );
      }}
    >
      {({ answer, onChange, onBlur }) =>
        desktop && !editorTimedOut ? (
          <EditorContainer>
            <CodeEditor
              skill={question.skill_name}
              value={answer}
              onChange={onChange}
              onBlur={onBlur}
              onTimeout={() => setEditorTimedOut(true)}
            />
          </EditorContainer>
        ) : (
          <CodeTextAnswer
            value={answer}
            placeholder={t`Write answer here...`}
            disabled={state.submitting}
            onChange={(event) => {
              onChange(event.target.value);
            }}
            onBlur={onBlur}
          />
        )
      }
    </DebouncedAnswer>
  );
}

//region Styles
const EditorContainer = styled.div`
  margin-top: -15px;
`;

const CodeTextAnswer = styled(DSTextAnswer)`
  font-family: "Roboto Mono", monospace;
`;
//endregion
